import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { validateToken, handleTokenExpiration } from '../../utils/authUtils';
import { logout } from '../../store/slices/authSlice';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  
  useEffect(() => {
    // Check token validity on component mount
    if (isAuthenticated && !validateToken()) {
      console.log('Token expired, logging out user');
      dispatch(logout());
    }
  }, [isAuthenticated, dispatch]);
  
  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;


